"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOutcomesMarketTradingStatus = exports.getCategoryMarketInfoFilteredTradingStatus = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const types_1 = require("../../../containers/EventsProvider/types");
const constants_1 = require("../constants");
// Helper function to set trading status for a Category Market Info based on the trading statuses of probabilities inside the Category Market Info
const getCategoryMarketInfoFilteredTradingStatus = ({ probabilities, eventStatus, }) => {
    return constants_1.EVENT_STATUSES_BETS_ENABLED.includes(eventStatus) && // Uncomment after business requirements resolved
        probabilities.some((probability) => probability.tradingStatus === betweb_openapi_axios_1.EventProbabilityTradingStatus.Trading)
        ? types_1.CategoryMarketInfoTradingStatus.Trading
        : undefined;
};
exports.getCategoryMarketInfoFilteredTradingStatus = getCategoryMarketInfoFilteredTradingStatus;
/*
Use instead of getCategoryMarketInfoFilteredTradingStatus for better names
*/
const getOutcomesMarketTradingStatus = ({ outcomes, eventStatus, }) => {
    return constants_1.EVENT_STATUSES_BETS_ENABLED.includes(eventStatus) && // Uncomment after business requirements resolved
        outcomes.some((outcome) => outcome.tradingStatus === betweb_openapi_axios_1.EventProbabilityTradingStatus.Trading)
        ? types_1.OutcomesMarketTradingStatus.Trading
        : undefined;
};
exports.getOutcomesMarketTradingStatus = getOutcomesMarketTradingStatus;
//# sourceMappingURL=getCategoryMarketInfoFilteredTradingStatus.js.map